import { render, staticRenderFns } from "./SendReminderInputs.vue?vue&type=template&id=f56d846e&scoped=true&"
import script from "./SendReminderInputs.vue?vue&type=script&lang=ts&"
export * from "./SendReminderInputs.vue?vue&type=script&lang=ts&"
import style0 from "./SendReminderInputs.vue?vue&type=style&index=0&id=f56d846e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d846e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
